// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterList_wrapper__3G8SO","label":"FilterList_label__2afQK","filtersBody":"FilterList_filtersBody__3r4Ju"};